/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import FindKnowledgeGraphRelationshipValuesRequest from './FindKnowledgeGraphRelationshipValuesRequest';
import FindKnowledgeGraphRelationshipValuesResponseHeadCeas from './FindKnowledgeGraphRelationshipValuesResponseHeadCeas';

/**
 * The FindKnowledgeGraphRelationshipValuesResponse model module.
 * @module model/FindKnowledgeGraphRelationshipValuesResponse
 * @version 2.8.0
 */
class FindKnowledgeGraphRelationshipValuesResponse {
    /**
     * Constructs a new <code>FindKnowledgeGraphRelationshipValuesResponse</code>.
     * @alias module:model/FindKnowledgeGraphRelationshipValuesResponse
     * @extends Object
     * @param requestReceived {module:model/FindKnowledgeGraphRelationshipValuesRequest} 
     */
    constructor(requestReceived) { 
        
        FindKnowledgeGraphRelationshipValuesResponse.initialize(this, requestReceived);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, requestReceived) { 
        obj['requestReceived'] = requestReceived;
    }

    /**
     * Constructs a <code>FindKnowledgeGraphRelationshipValuesResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FindKnowledgeGraphRelationshipValuesResponse} obj Optional instance to populate.
     * @return {module:model/FindKnowledgeGraphRelationshipValuesResponse} The populated <code>FindKnowledgeGraphRelationshipValuesResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FindKnowledgeGraphRelationshipValuesResponse();

            ApiClient.constructFromObject(data, obj, 'Object');
            

            if (data.hasOwnProperty('requestReceived')) {
                obj['requestReceived'] = FindKnowledgeGraphRelationshipValuesRequest.constructFromObject(data['requestReceived']);
            }
            if (data.hasOwnProperty('headCeas')) {
                obj['headCeas'] = ApiClient.convertToType(data['headCeas'], [FindKnowledgeGraphRelationshipValuesResponseHeadCeas]);
            }
            if (data.hasOwnProperty('tailCeas')) {
                obj['tailCeas'] = ApiClient.convertToType(data['tailCeas'], [FindKnowledgeGraphRelationshipValuesResponseHeadCeas]);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/FindKnowledgeGraphRelationshipValuesRequest} requestReceived
 */
FindKnowledgeGraphRelationshipValuesResponse.prototype['requestReceived'] = undefined;

/**
 * @member {Array.<module:model/FindKnowledgeGraphRelationshipValuesResponseHeadCeas>} headCeas
 */
FindKnowledgeGraphRelationshipValuesResponse.prototype['headCeas'] = undefined;

/**
 * @member {Array.<module:model/FindKnowledgeGraphRelationshipValuesResponseHeadCeas>} tailCeas
 */
FindKnowledgeGraphRelationshipValuesResponse.prototype['tailCeas'] = undefined;






export default FindKnowledgeGraphRelationshipValuesResponse;

